import clientSubscription from '@/utils/client.subscription'

const MUTATION_TYPES = {
  UPDATE_QUIZ_RESPONSE: 'UPDATE_QUIZ_RESPONSE',
}

const _state = {
  quizResult: null,
}

const _getters = {
  quizResult: (state) => {
    return state.quizResult
  },
}

const actions = {
  subscribeQuizResponseAction: async ({ dispatch }, payload) => {
    const { audienceId } = payload
    await dispatch('kvSync/subscribeKeyAction', {
      key: `QUIZ_RESULTS/${audienceId}`,
    }, {
      root: true,
    })
  },
}

const mutations = {
  [MUTATION_TYPES.UPDATE_QUIZ_RESPONSE](state, quizResult) {
    state.quizResult = quizResult
  },
}

const plugins = {
  updateQuizResponse: (store) => {
    store.subscribeAction((action) => {
      if (action.type === 'kvSync/updateKeyValueAction') {
        console.log('actionactionaction', action)
        const { key, value } = action.payload
        if (key.includes('QUIZ_RESULTS/')) {
          const quizResult = JSON.parse(value)
          console.log('quizResult', quizResult)
          const keySubscrible = `${clientSubscription.constantObjectSubcriptionType.submitQuizAnswerType}-${quizResult.slide}`
          console.log('key resolve', keySubscrible, clientSubscription.objectSubcription[keySubscrible])
          if (clientSubscription.objectSubcription[keySubscrible]) {
            clientSubscription.objectSubcription[keySubscrible].resolve(quizResult)
            delete clientSubscription.objectSubcription[keySubscrible] // Sau khi resolve, xóa đi khỏi objectSub (hoặc giữ lại nếu cần)
          }
          // store.commit(MUTATION_TYPES.UPDATE_QUIZ_RESPONSE, quizResult)
        }
      }
    })
  },
}

const quizModule = {
  namespaced: true,
  state: _state,
  getters: _getters,
  actions,
  mutations,
  plugins,
}

export default quizModule
